// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  vertical-align: middle;
  z-index: 1000;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-body {
  position: relative;
  background-color: #fff;
  border: none;
  color: #000;
  text-align: left;
  margin: 40px auto;
  border-radius: 7px;
  overflow: hidden;
  padding: 20px;
}
@media only screen and (max-width: 420px) {
  .modal-body {
    width: 90%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Modal/Modal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,oCAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AACF;AACE;EAXF;IAYI,UAAA;EAEF;AACF","sourcesContent":[".modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  text-align: center;\n  vertical-align: middle;\n  z-index: 1000;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.modal-body {\n  position: relative;\n  background-color: #fff;\n  border: none;\n  color: #000;\n  text-align: left;\n  margin: 40px auto;\n  border-radius: 7px;\n  overflow: hidden;\n  padding: 20px;\n\n  @media only screen and (max-width: 420px) {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
